<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-money-check-alt"></i> <ng-container i18n>Create a Tax</ng-container></h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="row">
    <div class="col-sm-5">
      <mat-form-field class="mat-block">
        <input type="text" formControlName="name" matInput required placeholder="Tax Name:" i18n-placeholder />
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')" i18n>
          Tax name is required
        </mat-error>
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('minlength')" i18n>
          Tax name must be at least 2 characters long
        </mat-error>
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('maxlength')" i18n>
          Tax name must be at most 50 characters long
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-sm-3">
      <mat-form-field class="mat-block">
        <mat-label><span [innerHtml]="form.get('type').value | amountPlaceholder : currencySymbol"></span></mat-label>
        <input type="number" min="0" formControlName="amount" matInput decimal="4" required />
        <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')" i18n>
          Amount is required
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-sm-4">
      <mat-form-field [floatLabel]="'never'" class="mat-block">
        <mat-select formControlName="type" placeholder="Type" i18n-placeholder>
          <mat-option value="percent" i18n>Percent</mat-option>
          <mat-option value="flat" i18n>Flat</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> <ng-container i18n>cancel</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-plus"></i> <ng-container i18n>create</ng-container>
  </button>
</div>
